import React from 'react'
import "./footer.css";

const Footer = () => {
  return (
    <footer className='footer'> Copyright @bid 2023, All Right Received.</footer>
  )
}

export default Footer;